<template>
  <div class="content s-introduction">
    <!-- <h2>{{$store.state.solutionName}}</h2> -->
    <h3 class="title-p">{{ title }}</h3>
    <p class="des" v-html="content"></p>
    <img :src='img' alt="加载失败" v-show="img">
    <!-- <el-image :src='img'></el-image> -->
    <!-- <img :src='img1' alt=""> -->
  </div>
</template>
<script>
import img1 from '../assets/1.png'
import { get, imageFile } from '../plugins/request.js'

export default {
  name: 'SIntroduction',
  props: {
    title: String
  },
  data() {
    return {
      content: '',
      img: ''
    }
  },
  methods: {
    getData() {
      const id = this.$store.state.currentLanguage.id
      const params = this.$route.params.id;
      const self = this;
      get('/solution_system.jsp', {langtype: id, sid: params}).then(function(res){
        const data0 = res.data.data;
        //console.log(data0)
        self.$store.commit('changeSolutionName', data0[0]['title_1'])
        self.img = imageFile(data0[0]['tupian'])
        self.content = data0[0].content
      })
    }
  },
  created: function(){
    this.getData()
  },
  watch: {
    '$route': function(to, from) {
      if(to.params.id){
         this.getData()
      }
    }
  }
}
</script>
<style lang="scss">
.s-introduction {
  .des{
    line-height: 1.7;
  }
    h2 {
      font-size: 1.4rem;
      margin: 0;
      font-weight: 400;
    }
    h3 {
      font-size: 1.1rem;
      margin: 0.5rem 0 1rem;
      font-weight: 400;
    }
    h4 {
      font-size: 0.9rem;
      font-weight: 400;
      margin: 1.5rem 0 0.5rem;
    }
    h5 {
      font-size: 0.8rem;
      margin: 1.5rem 00.5rem;
      font-weight: 400;
    }
    p{
      opacity: 0.7;
      line-height: 1.8;
    }
    img {
      margin-top: 2rem;
    }
 
}
</style>
